<template>
	<span class="check-mark-animation" ref="animated-check-mark" />
</template>

<script>
import lottie from 'lottie-web'
import animationData from '@/assets/animation/check-mark-animation.json'

export default {
	name: 'CheckMarkAnimation',

	data() {
		return {
			animatedLogo: null
		}
	},

	mounted() {
		this.animatedLogo = lottie.loadAnimation({
			container: this.$refs['animated-check-mark'],
			renderer: 'svg',
			loop: false,
			autoplay: true,
			animationData
		})
		this.animatedLogo.addEventListener('complete', () => {
			this.$emit('animation-complete')
		})
	},

	beforeDestroy() {
		this.animatedLogo.destroy()
	}
}
</script>

<style lang="scss">
.check-mark-animation {
	display: block;
	width: 70px;
	height: 70px;
	margin: 0 auto 10px;

	svg {
		width: 100%;
		height: 100%;
	}
}
</style>
